import { render, staticRenderFns } from "./EditTopicPage.vue?vue&type=template&id=642871c3"
import script from "./EditTopicPage.vue?vue&type=script&lang=js"
export * from "./EditTopicPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports